module.exports = __webpack_public_path__ + "img/joinimg.d02d3344.png";